import src from "IMAGE";
export default { src, width: 328, height: 60, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAI0lEQVR42mNgYGAIAuJILgaGqBp19aZkSclyRiAfKJYMxFEARukEf6N53u4AAAAASUVORK5CYII="};
